import { useQuery } from '@tanstack/react-query'
import { getDraftMeetings } from '../api/meetingApi'

/**
 * Taslak (360) toplantılar — tüm gruplardan, sayfalı. Taslaklar ekranı listeyi çeker; Toplantılar kartı
 * yalnız sayaç için {@code size: 1} ile çağırır (toplam `page.totalElements`'tan okunur).
 */
export function useDraftMeetings(page: number, size: number) {
  return useQuery({
    queryKey: ['draft-meetings', page, size],
    queryFn: () => getDraftMeetings({ page, size }),
  })
}
